module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('h4', {
    staticClass: "text-bold"
  }, [_vm._v("Dedicated Persons")]), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "secondary--text",
      "column": ""
    },
    model: {
      value: (_vm.selectedDedicatedPersons),
      callback: function($$v) {
        _vm.selectedDedicatedPersons = $$v
      },
      expression: "selectedDedicatedPersons"
    }
  }, _vm._l((_vm.userTypes), function(userType, typeIndex) {
    return _c('div', {
      key: typeIndex
    }, [_c('p', {
      staticClass: "h4 font-weight-bold mb-0"
    }, [_vm._v(_vm._s(userType.title))]), _vm._v(" "), _c('div', {
      staticClass: "mb-2",
      staticStyle: {
        "margin-left": "-7px"
      }
    }, _vm._l((_vm.filterByRole(_vm.assignUsers, userType.role)), function(item, index) {
      return _c('v-chip', {
        key: index,
        staticClass: "ma-2",
        attrs: {
          "value": item,
          "filter": "",
          "readonly": _vm.viewMode
        }
      }, [_c('v-avatar', {
        staticStyle: {
          "margin-right": "5px"
        }
      }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n            " + _vm._s(item.firstName + ' ' + item.lastName) + "\n          ")], 1)
    }), 1)])
  }), 0)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "text-bold"
  }, [_vm._v("Supporting Persons")]), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "secondary--text",
      "column": ""
    },
    model: {
      value: (_vm.selectedSupportingPersons),
      callback: function($$v) {
        _vm.selectedSupportingPersons = $$v
      },
      expression: "selectedSupportingPersons"
    }
  }, _vm._l((_vm.userTypes), function(userType, typeIndex) {
    return _c('div', {
      key: typeIndex
    }, [_c('p', {
      staticClass: "h4 font-weight-bold mb-0"
    }, [_vm._v(_vm._s(userType.title))]), _vm._v(" "), _c('div', {
      staticClass: "mb-2",
      staticStyle: {
        "margin-left": "-7px"
      }
    }, _vm._l((_vm.filterByRole(_vm.computedSupportingPersons, userType.role)), function(item, index) {
      return _c('v-chip', {
        key: index,
        staticClass: "ma-2",
        attrs: {
          "value": item,
          "filter": "",
          "readonly": _vm.viewMode
        }
      }, [_c('v-avatar', {
        staticStyle: {
          "margin-right": "5px"
        }
      }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n            " + _vm._s(item.firstName + ' ' + item.lastName) + "\n          ")], 1)
    }), 1)])
  }), 0)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-709478c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Client/AssignTeam.vue
// module id = 2186
// module chunks = 0